import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing the filter view for withdrawal requests.
 * @extends JetView
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const center_left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for state dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the state dropdown
                                {
                                    id: '',
                                    value: _('Todos'),
                                },
                                {
                                    id: 'A',
                                    value: _('Activo'),
                                },
                                {
                                    id: 'I',
                                    value: _('Inactivo'),
                                },
                                {
                                    id: 'R',
                                    value: _('Rechazado'),
                                },
                                {
                                    id: 'P',
                                    value: _('Pendiente'),
                                },
                                {
                                    id: 'E',
                                    value: _('Eliminado'),
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for IP address
                            name: 'Ip',
                            label: "<span class='icon-ip'></span>" + _('Direccion IP'), // Label for IP input
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for payment method selection
                            name: 'PaymentMethods',
                            label: "<span class='icon-credit-card'></span>" + _('Formas de Pago'), // Label for payment methods dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Options for the payment methods dropdown
                                {
                                    id: '0',
                                    value: _('Todos'),
                                },
                                {
                                    id: '1',
                                    value: _('Efectivo'),
                                },
                                {
                                    id: '2',
                                    value: _('Cuenta Bancaria'),
                                },
                                {
                                    id: '3',
                                    value: _('Giro Bancario'),
                                },
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };

        // Upper section containing the filter form
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [center_left], // Including the left section
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key triggers this button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('bonusReport:filter', [filterdata]); // Trigger filter event with values
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
